var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.66667 0.286377L0.953125 4.99992L5.66667 9.71346L6.66667 8.71346L3.61979 5.66658H13V4.33325H3.61979L6.66667 1.28638L5.66667 0.286377Z"}));
}

ArrowLeft.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
